import React, { useState } from "react";
import axios from "axios";

function NewsLetterArea(props) {

  const API_URL = "https://test.campfr.com/api/subscribe/";
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  const [responseMessage, setResponseMessage] = useState(null);
  const [displayTitle, setDisplayTitle] = useState("Stay up to date");
  const [displayText, setDisplayText] = useState("New workshops and opportunities go out to our mailing list first! Enter your email here, and we'll keep you up to date with news, workshops and opportunities at CAMP.");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    const payload = new URLSearchParams({
      email,
      ctype: props.ctype,
      item_id: props.item_id,
    });
    setLoading(true);

    try {
      const { data } = await axios.post(
      API_URL,
      payload,
      {
        headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-API-TOKEN": API_TOKEN
        },
      }
      );

      console.log(data);

      // Check if the response is as expected
      if (data && typeof data === "string") {
      setResponseMessage(data);
      } else {
      console.error("Unexpected response format:", data);
      setResponseMessage("Unexpected response from the server.");
      }
    } catch (err) {
      console.error("Error during API call:", err);
      setResponseMessage(
      "Sorry, something went wrong. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (props.ctype !== undefined) {
      console.log("props.ctype = "+props.ctype);
      setDisplayTitle("There's still a chance...");
      setDisplayText("Add your email to the waiting list, and get an alert when a place becomes available.");
    }
  }, [props.ctype]);

  return (
    <div className="newsletter-wrapper">
      <div className="container">
        <div className="row align-items-center">
          {/* ---------------------- LEFT SIDE ---------------------- */}
          <div className="col-lg-6">
            <div className="newsletter-side text-center text-lg-start mx-auto mx-lg-0">
              <h2>{displayTitle}</h2>
              <p>
                {displayText}
              </p>

              {responseMessage ? (
                <p className="newsletter-response">{responseMessage}</p>
              ) : (
                <form onSubmit={handleSubmit} id="newsletter-form">
                  <div className="newsletter-form-input">
                    <input
                      type="email"
                      name="email"
                      id="newsletter-input"
                      placeholder="Your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <button
                      type="submit"
                      className="newsletter-submit"
                      disabled={!email || loading}
                    >
                      {loading ? "Subscribing..." : "Subscribe"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>

          {/* ---------------------- RIGHT SIDE ---------------------- */}
          <div className="col-lg-6 ">
            <div className="achievement-counter-side">
              <div className="row g-4">
                <div className="col-lg-6  col-md-6">
                  <div className="achievement-box-style-one">
                    <div className="achievement-icon">
                      <i className="fa-solid fa-tower-cell fa-2xl"></i>
                    </div>
                    <div className="achievement-box-content">
                      <h4>Workshop news</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6  col-md-6">
                  <div className="achievement-box-style-one">
                    <div className="achievement-icon">
                      <i className="fa-solid fa-door-open fa-2xl"></i>
                    </div>
                    <div className="achievement-box-content">
                      <h4>Opportunities</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6  col-md-6">
                  <div className="achievement-box-style-one">
                    <div className="achievement-icon">
                      <i className="fa-solid fa-tag fa-2xl"></i>
                    </div>
                    <div className="achievement-box-content">
                      <h4>Discount offers</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6  col-md-6">
                  <div className="achievement-box-style-one">
                    <div className="achievement-icon">
                      <i className="fa-solid fa-bolt fa-2xl"></i>
                    </div>
                    <div className="achievement-box-content">
                      <h4>Exciting updates</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsLetterArea;
